export default {
  DASHBOARD: 'dashboard/',
  USER_DASHBOARD: 'dashboard/maintenance',
  BRANCH_DASHBOARD: 'dashboard/branch',
};
